<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>優惠兌換列表</h4>
            <h5>當前管理員: {{username}}</h5>
          </b-col>
           <b-col cols="6" class="text-right">
            <b-button v-if="permissionLevel<3.5" variant="success" size="md" @click="createCSV"><i class="fa fa-download mr-2"></i>Export as CSV</b-button>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable :keywordPlaceholder="placeholder" ref="table" :filters="filters" :actions="actions" :columns="updatedColumns" vuexModule="Homepage" searchAction="getRedemptionList" type="product">
          <template slot="leftEyeImage" slot-scope="data">
            <img v-if="data.data" :src="getImageUrl(data.data)" onerror="" class="imagePreview pr-3" width="120" style="height: auto;">
          </template>
           <template slot="rightEyeImage" slot-scope="data">
            <img v-if="data.data" :src="getImageUrl(data.data)" onerror="" class="imagePreview pr-3" width="120" style="height: auto;">
          </template>
        </FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">


const selectionInitial = {
    gender: [],
    brand: [],
    product: [], // With parentKey
    lens: [],
    degree: [], // With parentKey
    region: [],
    district: [], // With parentKey
    store: [], // With parentKey
    productType:[],
}

import { FITSearchableTable, FITFormCard } from '@/components'
import $ from 'jquery'
import Cookies from 'js-cookie'
import * as moment from 'moment';

export default {
  name: 'RedemptionList',
  props: {},
  components: {
    FITSearchableTable,
    FITFormCard,
  },
  created(){

        this.selections = selectionInitial;
        this.getAllSelections('selectionList');
        this.getAllSelections('storeList');
        // console.log(this.selections)
  },
  data(){
  	return{
      placeholder:'Telephone/ PromoteCode/ MerchantID',
      selections:{},
  		filters:[],
  		actions:[
        // {
        //   text: "兌換優惠碼",
        //   key: 'redeem',
        //   class:'text-primary',
        //   callback: (key, row, instance) => {
        //     // Vue.set(this, 'clickedRow', row);
        //     this.redeemRecord(row.ID,row.promoteStatus);
        //   }
        // },
        // {
        //   text: "刪除",
        //   key: 'delete',
        //   class: 'text-danger',
        //   permission:3.5,
        //   callback: (key, row, instance) => {
        //     // Vue.set(this, 'clickedRow', row);
        //     // console.log(row);
        //     this.deleteRecord(row.ID);
        //   }
        // }
        {
          text: "重新發送用戶SMS",
          key: 'resendUser',
          class: 'text-primary',
          permission:3.5,
          callback: (key, row, instance) => {
            this.resendRedemptionMsg(key,row);
          }
        },
        {
          text: "重新發送商戶SMS",
          key: 'resendStore',
          class: 'text-danger',
          permission:3.5,
          callback: (key, row, instance) => {
            this.resendRedemptionMsg(key,row);
          }
        }
      ],
  		columns:[
       {
          key: 'ID',
          label: '換領ID',
        },
         {
          key: 'promoteCode',
          label: '兌換優惠碼',
        },
        {
          key: 'clientTelephone',
          label: '客戶電話號碼',
          formatter: (row, key, item) => {
            return `<span class="tooltip1">`+ this.getTranslated('telephone', row)+`<span class="tooltiptext1">${row}</span> </span>`;
          }
        },
        {
          key: 'createTime',
          label: '兌換日期',
        },
        // {
        //   key: 'sightProduct',
        //   label: '近視/遠視',
        // },
        // {
        //   key: 'lightProduct',
        //   label: '散光',
        // },
        // {
        //   key: 'axisProduct',
        //   label: '漸進',
        // },
        // {
        //   key: 'leftEyeImage',
        //   label: '左眼圖片',
        //   template: true,

        // },
        //   {
        //   key: 'rightEyeImage',
        //   label: '右眼圖片',
        //   template: true,
        // },
        // {
        //   key: 'leftLOT',
        //   label: '左眼LOT碼',
        // },

        // {
        //   key: 'rightLOT',
        //   label: '右眼LOT碼',
        // },
        {
          key: 'redeemMerchant',
          label: '兌換商戶ID',
        },
        {
          key: 'redeemStoreName',
          label: '兌換店舖名稱',
        },
        {
          key: 'redeemStoreAddress',
          label: '兌換店舖地址',
          formatter: (row, key, item) => {
           return  item.redeemStoreDistrict + row ;
          }
        },
        {
          key: 'redeemStoreTelephone',
          label: '兌換店舖SMS電話',
        },

        {
          key: 'regStoreName',
          label: '註冊店舖名稱',
        },
        {
          key: 'regStoreAddress',
          label: '註冊店舖地址',
          formatter: (row, key, item) => {
           return  item.regStoreDistrict + row ;
          }
        },


        // {
        //   key: 'promoteStatus',
        //   label: '換領狀態',
        //   // tdClass:[],
        //   formatter: (row, key, item) => {
        //     let classStr = 'text-primary';
        //     if(row == "Y"){
        //       classStr = 'text-success'; 
        //     }
        //     let tag = `<span class="font-weight-bold ${classStr}">${this.getTranslated(key, row)}</span>`
        //     return tag;
        //   }
        // },
   
        // {
        //   key: 'updateTime',
        //   label: '換領日期',
        //   formatter: (row, key, item) => {
        //    return this.getTranslated(key, row);
        //   }
        // },

      ],
  	}
  },
  computed:{
    permissionLevel() {
      return Cookies.get('permissionLevel');
    },
    username() {
      return Cookies.get('username');
    },
    updatedColumns(){
      let columns = this.columns;
      let ignoreColumns = [
      'informationFlag',
      'emailFlag',
      'smsFlag'
      ];
      let columnIndex= 0;
      // if(this.permissionLevel >3.5){
      //   $.each(columns,(index,value)=>{
      //     if(value.key == 'informationFlag')
      //     {
      //        columnIndex = index ;
      //     }
      //   });
      //   columns.splice(columnIndex,3);    
      // }
      return columns;
    }
  },
  methods:{
    resendRedemptionMsg(type, record){



      if(type == 'resendUser'){
  
       var clientText= "感謝參加博士倫Biotrue 1-DAY體驗活動，請到博士倫香港 Facebook專頁留意最新優惠。";
       let clientParam ={
        telephone: record.clientTelephone,
        content: clientText
       };
       var confirmMsg = '確認重新發送至:\n'+"電話號碼: "+clientParam.telephone+"\n"+
       clientParam.content;
       if(!confirm(confirmMsg)){return}
       this.$store.dispatch('Homepage/sendSMS',clientParam);
       alert('用戶兌換確認短信已成功發送!');


      }else if (type == 'resendStore'){

         // contactNumber.merchant;
       var date = moment(record.createTime).format("YYYY-MM-DD");
       var promoteCode = record.promoteCode;
       var productText = '產品及數量: %0D';
       if(parseInt(record.sightProduct) > 0 ){
        productText += "<近視/遠視><"+ record.sightProduct +">盒%0D";
       }
       if(parseInt(record.lightProduct) > 0 ){
        productText += "<散光><"+ record.lightProduct +">盒%0D";
       }
       if(parseInt(record.axisProduct) > 0 ){
        productText += "<漸進><"+ record.axisProduct +">盒%0D";
       }

       var merchantText= "兌換日期: "+date+"%0D優惠碼: "+promoteCode+"%0D"+productText;
        let merchantParam ={
        telephone: record.redeemStoreTelephone,
        content:  merchantText
       };

      var confirmMsg2 = '確認重新發送至:\n'+"電話號碼: "+merchantParam.telephone+"\n"+
       merchantParam.content;
       // let confirmMerchantMsg = confirmMsg2.replace('%0D', '\n');
      if(!confirm(confirmMsg2)){return}

      this.$store.dispatch('Homepage/sendSMS',merchantParam);
       alert('商戶兌換確認短信已成功發送!');
      }
    },
    getImageUrl(row){
      let imageDomain = process.env.DOMAIN + "/"; // production
      // let imageDomain = "https://test.tarvel.co/biotrue/rest/";  // Development
      // console.log(row);
      return imageDomain + row;
    },
    createCSV(){
      this.$store.dispatch('Homepage/BIExportCSV',{type:'redemption'});
    },
    redeemRecord(ID,status){

      if(status == 'Y'){
        alert("該推廣優惠碼已兌換");
        return;
      }

      if(!confirm("確認兌換該用戶的推廣優惠碼？")){
        return ;
      }

      if(!ID){
        return;
      }
      this.$store.dispatch('Homepage/redeemBIRecord',{'ID':ID})
      .then((json) => {
        this.$refs.table.search({ page: 1, count: 25 });
      });


    },
    deleteRecord(ID){
        if(!confirm("確認刪除此優惠登記記錄？")){
        return ;
      }
      if(!ID){
        return;
      }
      this.$store.dispatch('Homepage/deleteBIRecord',{'ID':ID})
      .then((json) => {
        this.$refs.table.search({ page: 1, count: 25 });
      });

    },
    getSubDegree( parentKey,value ){

      let degree = "";
        $.each(this.selections.degree, (index,item)=>{
        if  ((item.parentKey == parentKey)&&(item.value == value)){
          degree = item.text;
        }   
      });

      return degree;
    },

    getTranslated(key,value){
      console.log(value)
      let result = "/";
      switch(key){
        case 'accountID':
        case 'store':
        $.each(this.selections.store, (index,item)=>{
        if(item.ID == value){
          if(key == 'accountID'){result = item.accountID;}
          else if(key == 'store'){result =   result = `${item.name} (${item.address})` ;}
        }   
         });
        break;

        case 'telephone':
        if(value != null){
          if (this.permissionLevel < 1) {
            result = value 
          }else{
            result = value.substring(0,4)+'****'
          }          
        }
          break;

        case 'updateTime':
        case 'createTime':
          if(value !=null){
          //   let dateTime = value.split(' ');
          // return dateTime[0];
          return value;
        }else{
          return '';
        }
          
        break;
        case 'promoteStatus':
        if(value == "Y"){
          return "已換領";
        }else{
          return "未領取";
        }

        break;
        
        case 'leftAxis':
        case 'rightAxis':
        result = this.getSubDegree("X",value);
        break;
        case 'leftShort':
        case 'rightShort':
          result = this.getSubDegree("S",value);
        break;
        case 'leftLight':
        case 'rightLight':
        result = this.getSubDegree("L",value);
        break;
        case 'informationFlag':
        case 'smsFlag':
        case 'emailFlag':

          if(value == "true"){
            result = '是';
          }else if(value == "false"){
            result = '否';
          }else{
            result = 'N/A';
          }
        break;
        default:
      $.each(this.selections[key], (index,item)=>{
        if(item.value == value){
          result = item.text;
        }   
      });
        break;

      }


      return result;

    },

    setAllSelections(list) {
            // console.log(list);
            $.each(list, (index, item) => {
                if (this.selections[item.type]) {
                    // if (item.parentKey) {
                    //     if (!this.selections[item.type][item.parentKey]) {
                    //         this.selections[item.type][item.parentKey] = [];
                    //     }
                    //     this.selections[item.type][item.parentKey].push(item);
                    // } else { // without parentKey
                    //     this.selections[item.type].push(item);
                    // }
                    this.selections[item.type].push(item);

                }
            });
            // console.log(this.selections);
        },

      getAllSelections(key) {

    this.$store.dispatch('Homepage/getBISelections',key)
      .then((json) => {
            this.setAllSelections( json.data.list);   
      });


            // $.ajax({
            //         url: `${config.apiDomain}/selection/${key}List`,
            //         type: 'GET',
            //         dataType: 'json',
            //         data: {},
            //     })
            //     .done((data) => {
            //         if (data.status != 200) {
            //             alert(`getAll${key} Error: ${data.status}`);
            //             return;
            //         }
            //         // console.log(data);
            //         this.setAllSelections(key, data.data.list);
            //     })
            //     .fail(function() {
            //         alert(`getAll${key} fail`);
            //     })
        },

  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/Registration/RedemptionList.vue